import { type ReactNode } from 'react';

import { ClassNames, css, legacyTheme } from '@prose-ui/legacy';

const rootStyles = css({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  margin: '20px 0',
  [legacyTheme.breakpoints.match('sm')]: {
    margin: 0,
  },
});

type SceneContainerProps = {
  className?: string;
  children: ReactNode;
};

const SceneContainer = ({ className, children }: SceneContainerProps) => {
  return (
    <ClassNames>
      {({ cx, css: parseSerializedCSS }) => (
        <div className={cx(parseSerializedCSS(rootStyles), className)}>{children}</div>
      )}
    </ClassNames>
  );
};

export default SceneContainer;
